module.exports = __webpack_public_path__ + "static/media/ideia.b6ec224e.png";